export default function Error() {
    return (
        <p style={{ textAlign: "center" }}>
            <b>Loading failed. Please try again later</b>
        </p>
    );
}